if (!customElements.get("description-toggle")) {
  class DescriptionToggle extends HTMLElement {
    constructor() {
      super();
      this.onClickBound = this.onClick.bind(this);
    }

    connectedCallback() {
      this.btn = this.querySelector(".description-toggle__btn");
      this.content = this.querySelector(".description-toggle__content");
      if (this.btn) {
        this.btn.addEventListener("click", this.onClickBound);
      }
    }

    disconnectedCallback() {
      if (this.btn) {
        this.btn.removeEventListener("click", this.onClickBound);
      }
    }

    onClick() {
      const expanded = this.btn.getAttribute("aria-expanded") === "true";
      this.btn.setAttribute("aria-expanded", String(!expanded));
      this.content.classList.toggle("is-open", !expanded);
    }
  }

  customElements.define("description-toggle", DescriptionToggle);
}
